import React from 'react';
import { Link } from 'react-router-dom';
import './SectorPage.css';

const SectorPage = ({ sector }) => {
  return (
    <section className="sector-section">
      <div className="sector-container">
        <div className="sector-header">
          <h1 className="sector-title">{sector.title}</h1>
          <p className="sector-subtitle">{sector.subtitle}</p>
          <p className="sector-intro">
            {sector.intro}
          </p>
        </div>

        <div className="sector-content">
          <div className="sector-block">
            <h2 className="block-title">Les enjeux spécifiques {sector.titleContext}</h2>
            <div className="block-content">
              <p>
                Si vous évoluez dans le secteur {sector.name}, vous faites face à une compétition accrue, à des cycles de vente parfois longs et à une complexification des canaux de décision. Dans ce contexte, une entreprise comme la vôtre peut :
              </p>
              <ul className="sector-list">
                <li>Avoir besoin de démontrer sa valeur dès les premiers contacts</li>
                <li>Rencontrer des difficultés pour identifier les bons interlocuteurs dans des organisations complexes</li>
                <li>Souhaiter maintenir un flux constant d'opportunités qualifiées sans mobiliser excessivement ses équipes internes</li>
              </ul>
              <p>
                Or, de nombreuses entreprises du secteur {sector.name} peinent à mettre en place une prospection structurée, ciblée et efficace, faute de ressources, d'outils ou de temps.
              </p>
            </div>
          </div>

          <div className="sector-block">
            <h2 className="block-title">Comment Prosperian répond aux défis {sector.responseContext}</h2>
            <div className="block-content">
              <p>
                La Suite Prosperian permet de déployer rapidement une stratégie d'acquisition adaptée aux spécificités du secteur {sector.name} grâce à :
              </p>
              <ul className="sector-list">
                <li>Une analyse de votre maturité commerciale via notre Pre-Score™</li>
                <li>Une stratégie personnalisée alignée sur vos objectifs de développement</li>
                <li>L'orchestration de campagnes multi-canales ciblant les bons décideurs :
                  <ul className="nested-list">
                    <li>Emailing personnalisé</li>
                    <li>LinkedIn (messages, Ads, advocacy)</li>
                    <li>Webinaires thématiques</li>
                    <li>Vidéos / Landing pages avec ROI calculator</li>
                    <li>Appels qualifiés et scoring dynamique</li>
                  </ul>
                </li>
                <li>La gestion intégrale de votre prospection : de la prise de contact à la prise de RDV qualifiés</li>
                <li>Un dashboard en temps réel pour mesurer vos performances</li>
              </ul>
            </div>
          </div>

          <div className="sector-block">
            <h2 className="block-title">Ce que vous pouvez attendre de Prosperian</h2>
            <div className="block-content">
              <ul className="sector-list benefits-list">
                <li>Une augmentation nette du nombre d'opportunités qualifiées</li>
                <li>Une prospection déléguée mais 100 % alignée sur votre offre</li>
                <li>Des messages pensés pour vos cibles, dans le langage de votre secteur</li>
                <li>Un gain de temps significatif pour vos équipes commerciales</li>
                <li>Des cycles de vente accélérés</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="sector-cta">
        <div className="sector-container">
          <div className="cta-item">
            <div className="cta-icon">🔍</div>
            <div className="cta-content">
              <h3>Testez votre maturité commerciale avec le Pre-Score Prosperian™</h3>
              <p>En 3 minutes, identifiez vos axes d'amélioration prioritaires et votre niveau d'éligibilité au programme.</p>
              <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
                <button className="cta-button">OBTENIR MON SCORE</button>
              </a>
            </div>
          </div>
          
          <div className="cta-item">
            <div className="cta-icon">📅</div>
            <div className="cta-content">
              <h3>Réservez une session découverte avec un expert {sector.expertContext}</h3>
              <p>Nos spécialistes vous présenteront une feuille de route sur-mesure pour accélérer votre prospection.</p>
              <a href="https://calendly.com/prosperian/rendez-vous-decouverte" target="_blank" rel="noopener noreferrer">
                <button className="cta-button secondary">DEMANDER UNE DÉMO</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectorPage; 